(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initCarousel(root) {
      if (!root || root.dataset.pvcReady === 'true') return;
      root.dataset.pvcReady = 'true';

      var track = root.querySelector('[data-pvc-track]');
      if (!track) return;
      var prev = root.querySelector('[data-pvc-prev]');
      var next = root.querySelector('[data-pvc-next]');
      var autoplay = root.dataset.autoplay === 'true' && !reduceMotion;
      var cards = root.querySelectorAll('[data-pvc-card]');

      function step() {
        var slide = track.querySelector('.pvc__slide');
        if (!slide) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        var overflow = track.scrollWidth - track.clientWidth > 4;
        track.classList.toggle('is-static', !overflow);
        if (prev) {
          prev.hidden = !overflow;
          prev.disabled = track.scrollLeft <= 2;
        }
        if (next) {
          next.hidden = !overflow;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { updateArrows(); ticking = false; });
      }, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      /* Self-hosted video cards */
      function muteOthers(except) {
        cards.forEach(function (c) {
          var v = c.querySelector('video');
          var b = c.querySelector('[data-pvc-sound]');
          if (v && v !== except) {
            v.muted = true;
            if (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Turn sound on'); }
          }
        });
      }

      cards.forEach(function (card) {
        var video = card.querySelector('video');
        if (!video) return;
        var poster = card.getAttribute('data-poster');
        if (poster) video.setAttribute('poster', poster);
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        card.setAttribute('tabindex', '0');
        card.setAttribute('role', 'button');
        card.setAttribute('aria-label', 'Play or pause video');

        video.addEventListener('play', function () { card.classList.add('is-playing'); });
        video.addEventListener('pause', function () { card.classList.remove('is-playing'); });

        function toggle() {
          if (video.paused) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
            card.dataset.userPaused = 'false';
          } else {
            video.pause();
            card.dataset.userPaused = 'true';
          }
        }
        card.addEventListener('click', toggle);
        card.addEventListener('keydown', function (e) {
          if (e.target !== card) return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });

        var sound = card.querySelector('[data-pvc-sound]');
        if (sound) {
          sound.addEventListener('click', function (e) {
            e.stopPropagation();
            var turnOn = video.muted;
            if (turnOn) muteOthers(video);
            video.muted = !turnOn;
            sound.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
            sound.setAttribute('aria-label', turnOn ? 'Turn sound off' : 'Turn sound on');
            if (turnOn && video.paused) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          });
        }
      });

      /* Autoplay (muted) while visible, pause when scrolled away */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var card = entry.target;
            var video = card.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              if (autoplay && card.dataset.userPaused !== 'true') {
                var p = video.play();
                if (p && p.catch) p.catch(function () {});
              }
            } else {
              video.pause();
            }
          });
        }, { threshold: [0, 0.6, 1] });
        cards.forEach(function (c) { if (c.querySelector('video')) io.observe(c); });
      }

      /* YouTube / Vimeo cards: load the player only when tapped */
      root.querySelectorAll('[data-pvc-embed]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var url = btn.getAttribute('data-pvc-embed');
          if (!url) return;
          var frame = document.createElement('iframe');
          frame.src = url;
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.setAttribute('allowfullscreen', '');
          frame.title = 'Product video';
          btn.parentNode.replaceChild(frame, btn);
        });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-pvc]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
